import { render, staticRenderFns } from "./product_slider.vue?vue&type=template&id=ee358c46&scoped=true&"
import script from "./product_slider.vue?vue&type=script&lang=js&"
export * from "./product_slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee358c46",
  null
  
)

export default component.exports